var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1C6.713 1 2.298 4.73 1.24 9.7c-.27 1.278.767 2.3 1.914 2.3H11v7a4 4 0 0 0 8 0 1 1 0 1 0-2 0 2 2 0 1 1-4 0v-7h7.846c1.147 0 2.185-1.022 1.913-2.3C21.702 4.73 17.287 1 12 1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }